var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDimensionalBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000127016840984459794320000013331435541868175533_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.threeDimensionalBag-st0{fill:#FFFFFF;stroke:currentColor;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "threeDimensionalBag-st0",
    d: "M73.3,59.4V21L40,1.7L6.7,21v38.4c0.5,0.8,11.9,19.2,33.7,19C61.7,78.2,72.7,60.4,73.3,59.4z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "threeDimensionalBag-st0",
    points: "73.2,21 39.9,40.2 6.7,21  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDimensionalBag);
export default __webpack_public_path__ + "static/media/threeDimensionalBag.e64709f45fe5b456e8c3c50eb582bcb0.svg";
export { ForwardRef as ReactComponent };